export class UserRef {
    id: number;
    name: string;
    code: string;
    mobile?: string;
    designation?: string;
    active?: boolean;
}